import Head from 'next/head';
import Image from 'next/image';
import { useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { ArrowLocation } from '../assets/icons';
import { locationImg } from '../assets/images';
function ContactUs() {
  const [message, setMessage] = useState('');

  function handleMessageSubmit(e) {
    e.preventDefault();
    toast.success('Message sent');
  }

  return (
    <div>
      <Head>
        <title>Contact 24hrdoc | Online Doctor Support</title>
        <meta
          name='description'
          content='Contact 24hrdoc for help with online doctor visits, prescriptions, refills, account questions, and telehealth support.'
        />
        <meta
          property='og:image'
          content={
            'https://www.24hrdoc.com/_next/image?url=%2Fassets%2Ficons%2FLogoTransparent.png&w=256&q=75'
          }
        />
        <link rel='canonical' href='https://www.24hrdoc.com/contact-us' />
      </Head>
      <div className='heroWrapper' style={{ height: '530px' }}>
        <div className='heroContent'>
          <h1 className='heroHeading'>Contact 24hrdoc</h1>
          <p className='heroPara'>
            Feel free to give us a call or send us an email with your questions
            or comments.
          </p>
        </div>
      </div>
      <Container
        fluid
        //style={{ marginTop: '-350px' }}
        className='contactContainer'
      >
        <Row className='px-0'>
          <Col
            //style={{ padding: ' .5rem 2rem ', backgroundColor: '#f6f6f6' }}
            className='theContactUsForm'
          >
            <Form
              style={{ paddingBottom: '1.5rem' }}
              onSubmit={handleMessageSubmit}
            >
              <Row className='px-0'>
                {' '}
                <Col xs={12} lg={6}>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label className='contactUsFormLabel'>
                      First Name
                    </Form.Label>
                    <Form.Control
                      className='contactUsFormInput'
                      type='text'
                      placeholder='Enter your first name'
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} lg={6}>
                  <Form.Group className='mb-3' controlId='formBasicEmail'>
                    <Form.Label className='contactUsFormLabel'>
                      Last Name
                    </Form.Label>
                    <Form.Control
                      className='contactUsFormInput'
                      type='text'
                      placeholder='Enter your last name'
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} lg={6}>
                  <Form.Group className='mb-3' controlId='formBasicPassword'>
                    <Form.Label className='contactUsFormLabel'>
                      Email Address
                    </Form.Label>
                    <Form.Control
                      className='contactUsFormInput'
                      type='email'
                      placeholder='Example@ymail.com'
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} lg={6}>
                  {' '}
                  <Form.Group className='mb-3' controlId='formBasicPassword'>
                    <Form.Label className='contactUsFormLabel'>
                      Phone Number
                    </Form.Label>
                    <div
                      style={{
                        //backgroundColor: 'yellow',
                        position: 'relative',
                      }}
                    >
                      <div className='country-code'>
                        <span className='flag'>
                          <USflag />
                        </span>
                        <span className='code'>+1</span>
                        <span className='dropdown-icon'>▼</span>
                      </div>
                      <Form.Control
                        className='contactUsFormInput'
                        type='number'
                        placeholder='000 - 000 - 000'
                        required
                        style={{ paddingLeft: '7rem' }}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Form.Group className='mb-3' controlId='formBasicPassword'>
                  <Form.Label className='contactUsFormLabel'>
                    Message
                  </Form.Label>
                  {/* <Form.Control
                    type='text'
                    placeholder='Write your message here'
                    required
                    rows={5}
                  /> */}
                  <Form.Control
                    style={{ borderRadius: '0.75rem' }}
                    className='contactUsFormInput'
                    as='textarea'
                    rows={5} // Adjust rows for longer input
                    placeholder='Write your message here'
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Form.Group>
                <Button
                  type='submit'
                  size='lg'
                  // style={{
                  //   width: '100%',
                  //   color: 'white',
                  //   fontWeight: '500',
                  //   //backgroundColor: '#41c9a2',
                  //   backgroundColor: 'black',
                  //   border: 'none',
                  //   borderRadius: '6.25rem',
                  //   marginTop: '1.5rem',
                  //   fontFamily: 'Poppins, Lato, sans-serif',
                  //   fontSize: '1rem',
                  //   padding: '1rem 2rem',
                  //   width: '230px',
                  // }}
                  className='contact-us-btn'
                >
                  Send Message
                </Button>
              </Row>
            </Form>
          </Col>
          <Col className='' sm={12} style={{ marginBottom: '6.25rem' }}>
            <h2 className='locationTitle'>Location</h2>
            <div className='locationImg'>
              <Image
                src={locationImg}
                alt='Our location'
                layout='fill'
                objectFit='cover'
                quality={80}
                style={{
                  //width: '100%',
                  //height: '100%',
                  borderRadius: '1.25rem',
                }}
              />
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  zIndex: '2',
                }}
              >
                <div style={{}} className='theAddress'>
                  {' '}
                  <p className='office'>Our Office</p>
                  <p className='address'>
                    3050 Post Oak Blvd, Houston, TX 77056
                  </p>
                  <a
                    href='https://www.google.com/maps/search/?api=1&query=3050+Post+Oak+Blvd,+Houston,+TX+77056'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <div className='mapButton'>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          whiteSpace: 'nowrap',
                          columGap: '0.5rem',
                        }}
                      >
                        <span className='openMap'>Open Map</span>
                        <span>
                          <ArrowLocation />
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ContactUs;
const USflag = () => (
  <svg
    width='27'
    height='20'
    viewBox='0 0 27 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_16973_45794)'>
      <path d='M0 0H26.6667V1.53848H0V0Z' fill='#F90407' />
      <path d='M0 1.53848H26.6667V3.07694H0V1.53848Z' fill='white' />
      <path d='M0 3.07694H26.6667V4.6154H0V3.07694Z' fill='#F90407' />
      <path d='M0 4.6154H26.6667V6.15386H0V4.6154Z' fill='white' />
      <path d='M0 6.15386H26.6667V7.69232H0V6.15386Z' fill='#F90407' />
      <path d='M0 7.69232H26.6667V9.23078H0V7.69232Z' fill='white' />
      <path d='M0 9.23078H26.6667V10.7692H0V9.23078Z' fill='#F90407' />
      <path d='M0 10.7692H26.6667V12.3077H0V10.7692Z' fill='white' />
      <path d='M0 12.3077H26.6667V13.8462H0V12.3077Z' fill='#F90407' />
      <path d='M0 13.8462H26.6667V15.3846H0V13.8462Z' fill='white' />
      <path d='M0 15.3846H26.6667V16.9231H0V15.3846Z' fill='#F90407' />
      <path d='M0 16.9231H26.6667V18.4615H0V16.9231Z' fill='white' />
      <path d='M0 18.4615H26.6667V20H0V18.4615Z' fill='#F90407' />
      <path d='M0 0H13.3333V10.7692L0 10.7692V0Z' fill='#0039A4' />
      <path
        d='M1.28055 1.3956L1.39205 1.7293L1.74452 1.73197C1.79017 1.73237 1.80906 1.79045 1.77237 1.8175L1.48883 2.02649L1.59519 2.36183C1.609 2.40522 1.55941 2.44121 1.52227 2.41468L1.23553 2.21019L0.94879 2.41473C0.911642 2.44121 0.862169 2.40528 0.875864 2.36189L0.982228 2.02655L0.698686 1.81756C0.661995 1.79045 0.680882 1.73243 0.726532 1.73203L1.07901 1.72935L1.19051 1.39566C1.20489 1.35238 1.26606 1.35238 1.28055 1.3956Z'
        fill='white'
      />
      <path
        d='M1.28055 3.14121L1.39205 3.47491L1.74452 3.47758C1.79017 3.47798 1.80906 3.53606 1.77237 3.56311L1.48883 3.7721L1.59519 4.10744C1.609 4.15084 1.55941 4.18682 1.52227 4.16029L1.23553 3.9558L0.94879 4.16035C0.911642 4.18682 0.862169 4.15089 0.875864 4.1075L0.982228 3.77216L0.698686 3.56317C0.661995 3.53606 0.680882 3.47804 0.726532 3.47764L1.07901 3.47496L1.19051 3.14127C1.20489 3.09805 1.26606 3.09805 1.28055 3.14121Z'
        fill='white'
      />
      <path
        d='M1.28055 4.88666L1.39205 5.22035L1.74452 5.22303C1.79017 5.22343 1.80906 5.28151 1.77237 5.30856L1.48883 5.51755L1.59519 5.85289C1.609 5.89628 1.55941 5.93227 1.52227 5.90574L1.23553 5.70125L0.94879 5.90579C0.911642 5.93227 0.862169 5.89634 0.875864 5.85295L0.982228 5.5176L0.698686 5.30862C0.661995 5.28151 0.680882 5.22349 0.726532 5.22309L1.07901 5.22041L1.19051 4.88672C1.20489 4.8435 1.26606 4.8435 1.28055 4.88666Z'
        fill='white'
      />
      <path
        d='M1.28055 6.63236L1.39205 6.96605L1.74452 6.96873C1.79017 6.96912 1.80906 7.02721 1.77237 7.05426L1.48883 7.26324L1.59519 7.59859C1.609 7.64198 1.55941 7.67797 1.52227 7.65143L1.23553 7.44694L0.94879 7.65149C0.911642 7.67797 0.862169 7.64204 0.875864 7.59864L0.982228 7.2633L0.698686 7.05431C0.661995 7.02721 0.680882 6.96918 0.726532 6.96878L1.07901 6.96611L1.19051 6.63241C1.20489 6.58914 1.26606 6.58914 1.28055 6.63236Z'
        fill='white'
      />
      <path
        d='M1.28055 8.37785L1.39205 8.71154L1.74452 8.71422C1.79017 8.71462 1.80906 8.7727 1.77237 8.79975L1.48883 9.00873L1.59519 9.34408C1.609 9.38747 1.55941 9.42346 1.52227 9.39692L1.23553 9.19244L0.94879 9.39698C0.911642 9.42346 0.862169 9.38753 0.875864 9.34414L0.982228 9.00879L0.698686 8.7998C0.661995 8.7727 0.680882 8.71467 0.726532 8.71427L1.07901 8.7116L1.19051 8.37791C1.20489 8.33457 1.26606 8.33457 1.28055 8.37785Z'
        fill='white'
      />
      <path
        d='M2.63879 2.25144L2.75028 2.58513L3.10276 2.58781C3.14841 2.58821 3.1673 2.64629 3.1306 2.67334L2.84706 2.88233L2.95343 3.21767C2.96724 3.26106 2.91765 3.29705 2.8805 3.27052L2.59376 3.06597L2.30703 3.27052C2.26988 3.297 2.2204 3.26106 2.2341 3.21767L2.34046 2.88233L2.05692 2.67334C2.02023 2.64624 2.03912 2.58821 2.08477 2.58781L2.43724 2.58513L2.54874 2.25144C2.56306 2.20828 2.62435 2.20828 2.63879 2.25144Z'
        fill='white'
      />
      <path
        d='M2.63879 3.99693L2.75028 4.33063L3.10276 4.3333C3.14841 4.3337 3.1673 4.39178 3.1306 4.41883L2.84706 4.62782L2.95343 4.96316C2.96724 5.00655 2.91765 5.04254 2.8805 5.01601L2.59376 4.81146L2.30703 5.01601C2.26988 5.04249 2.2204 5.00661 2.2341 4.96316L2.34046 4.62782L2.05692 4.41883C2.02023 4.39173 2.03912 4.3337 2.08477 4.3333L2.43724 4.33063L2.54874 3.99693C2.56306 3.95371 2.62435 3.95371 2.63879 3.99693Z'
        fill='white'
      />
      <path
        d='M2.63879 5.74258L2.75028 6.07628L3.10276 6.07895C3.14841 6.07935 3.1673 6.13744 3.1306 6.16448L2.84706 6.37347L2.95343 6.70882C2.96724 6.75221 2.91765 6.7882 2.8805 6.76166L2.59376 6.55712L2.30703 6.76166C2.26988 6.78814 2.2204 6.75221 2.2341 6.70882L2.34046 6.37347L2.05692 6.16448C2.02023 6.13738 2.03912 6.07935 2.08477 6.07895L2.43724 6.07628L2.54874 5.74258C2.56306 5.69936 2.62435 5.69936 2.63879 5.74258Z'
        fill='white'
      />
      <path
        d='M2.63879 7.48819L2.75028 7.82189L3.10276 7.82456C3.14841 7.82496 3.1673 7.88305 3.1306 7.91009L2.84706 8.11908L2.95343 8.45442C2.96724 8.49782 2.91765 8.5338 2.8805 8.50727L2.59376 8.30272L2.30703 8.50727C2.26988 8.53375 2.2204 8.49782 2.2341 8.45442L2.34046 8.11908L2.05692 7.91009C2.02023 7.88299 2.03912 7.82496 2.08477 7.82456L2.43724 7.82189L2.54874 7.48819C2.56306 7.44503 2.62435 7.44503 2.63879 7.48819Z'
        fill='white'
      />
      <path
        d='M3.99661 1.39561L4.10811 1.7293L4.46059 1.73198C4.50624 1.73238 4.52513 1.79046 4.48843 1.81751L4.20489 2.0265L4.31126 2.36184C4.32506 2.40523 4.27548 2.44122 4.23833 2.41468L3.95159 2.21014L3.66485 2.41468C3.62771 2.44116 3.57823 2.40523 3.59193 2.36184L3.69829 2.0265L3.41475 1.81751C3.37806 1.7904 3.39695 1.73238 3.4426 1.73198L3.79507 1.7293L3.90657 1.39561C3.92095 1.35239 3.98218 1.35239 3.99661 1.39561Z'
        fill='white'
      />
      <path
        d='M3.99661 3.14122L4.10811 3.47491L4.46059 3.47759C4.50624 3.47799 4.52513 3.53607 4.48843 3.56312L4.20489 3.77211L4.31126 4.10745C4.32506 4.15084 4.27548 4.18683 4.23833 4.16029L3.95159 3.95575L3.66485 4.16029C3.62771 4.18677 3.57823 4.15084 3.59193 4.10745L3.69829 3.77211L3.41475 3.56312C3.37806 3.53601 3.39695 3.47799 3.4426 3.47759L3.79507 3.47491L3.90657 3.14122C3.92095 3.09806 3.98218 3.09806 3.99661 3.14122Z'
        fill='white'
      />
      <path
        d='M3.99661 4.88667L4.10811 5.22036L4.46059 5.22304C4.50624 5.22344 4.52513 5.28152 4.48843 5.30857L4.20489 5.51756L4.31126 5.8529C4.32506 5.89629 4.27548 5.93228 4.23833 5.90575L3.95159 5.7012L3.66485 5.90575C3.62771 5.93223 3.57823 5.89629 3.59193 5.8529L3.69829 5.51756L3.41475 5.30857C3.37806 5.28146 3.39695 5.22344 3.4426 5.22304L3.79507 5.22036L3.90657 4.88667C3.92095 4.8435 3.98218 4.8435 3.99661 4.88667Z'
        fill='white'
      />
      <path
        d='M3.99661 6.63236L4.10811 6.96606L4.46059 6.96873C4.50624 6.96913 4.52513 7.02722 4.48843 7.05426L4.20489 7.26325L4.31126 7.59859C4.32506 7.64199 4.27548 7.67797 4.23833 7.65144L3.95159 7.44689L3.66485 7.65144C3.62771 7.67792 3.57823 7.64199 3.59193 7.59859L3.69829 7.26325L3.41475 7.05426C3.37806 7.02716 3.39695 6.96913 3.4426 6.96873L3.79507 6.96606L3.90657 6.63236C3.92095 6.58914 3.98218 6.58914 3.99661 6.63236Z'
        fill='white'
      />
      <path
        d='M3.99661 8.37785L4.10811 8.71155L4.46059 8.71422C4.50624 8.71462 4.52513 8.77271 4.48843 8.79976L4.20489 9.00874L4.31126 9.34409C4.32506 9.38748 4.27548 9.42347 4.23833 9.39693L3.95159 9.19239L3.66485 9.39693C3.62771 9.42341 3.57823 9.38748 3.59193 9.34409L3.69829 9.00874L3.41475 8.79976C3.37806 8.77265 3.39695 8.71462 3.4426 8.71422L3.79507 8.71155L3.90657 8.37785C3.92095 8.33458 3.98218 8.33458 3.99661 8.37785Z'
        fill='white'
      />
      <path
        d='M5.35485 2.25144L5.46635 2.58513L5.81882 2.58781C5.86447 2.58821 5.88336 2.64629 5.84667 2.67334L5.56313 2.88233L5.66949 3.21767C5.6833 3.26106 5.63371 3.29705 5.59657 3.27052L5.30983 3.06597L5.02309 3.27052C4.98594 3.297 4.93647 3.26106 4.95016 3.21767L5.05653 2.88233L4.77299 2.67334C4.7363 2.64624 4.75518 2.58821 4.80083 2.58781L5.15331 2.58513L5.26481 2.25144C5.27913 2.20828 5.34041 2.20828 5.35485 2.25144Z'
        fill='white'
      />
      <path
        d='M5.35485 3.99693L5.46635 4.33063L5.81882 4.3333C5.86447 4.3337 5.88336 4.39178 5.84667 4.41883L5.56313 4.62782L5.66949 4.96316C5.6833 5.00655 5.63371 5.04254 5.59657 5.01601L5.30983 4.81146L5.02309 5.01601C4.98594 5.04249 4.93647 5.00661 4.95016 4.96316L5.05653 4.62782L4.77299 4.41883C4.7363 4.39173 4.75518 4.3337 4.80083 4.3333L5.15331 4.33063L5.26481 3.99693C5.27913 3.95371 5.34041 3.95371 5.35485 3.99693Z'
        fill='white'
      />
      <path
        d='M5.35485 5.74258L5.46635 6.07628L5.81882 6.07895C5.86447 6.07935 5.88336 6.13744 5.84667 6.16448L5.56313 6.37347L5.66949 6.70882C5.6833 6.75221 5.63371 6.7882 5.59657 6.76166L5.30983 6.55712L5.02309 6.76166C4.98594 6.78814 4.93647 6.75221 4.95016 6.70882L5.05653 6.37347L4.77299 6.16448C4.7363 6.13738 4.75518 6.07935 4.80083 6.07895L5.15331 6.07628L5.26481 5.74258C5.27913 5.69936 5.34041 5.69936 5.35485 5.74258Z'
        fill='white'
      />
      <path
        d='M5.35485 7.48819L5.46635 7.82189L5.81882 7.82456C5.86447 7.82496 5.88336 7.88305 5.84667 7.91009L5.56313 8.11908L5.66949 8.45442C5.6833 8.49782 5.63371 8.5338 5.59657 8.50727L5.30983 8.30272L5.02309 8.50727C4.98594 8.53375 4.93647 8.49782 4.95016 8.45442L5.05653 8.11908L4.77299 7.91009C4.7363 7.88299 4.75518 7.82496 4.80083 7.82456L5.15331 7.82189L5.26481 7.48819C5.27913 7.44503 5.34041 7.44503 5.35485 7.48819Z'
        fill='white'
      />
      <path
        d='M6.7107 1.39561L6.8222 1.7293L7.17467 1.73198C7.22032 1.73238 7.23921 1.79046 7.20252 1.81751L6.91898 2.0265L7.02534 2.36184C7.03915 2.40523 6.98956 2.44122 6.95242 2.41468L6.66562 2.21014L6.37888 2.41468C6.34174 2.44116 6.29226 2.40523 6.30596 2.36184L6.41232 2.0265L6.12878 1.81751C6.09209 1.7904 6.11098 1.73238 6.15663 1.73198L6.5091 1.7293L6.6206 1.39561C6.63504 1.35239 6.69626 1.35239 6.7107 1.39561Z'
        fill='white'
      />
      <path
        d='M6.7107 3.14122L6.8222 3.47491L7.17467 3.47759C7.22032 3.47799 7.23921 3.53607 7.20252 3.56312L6.91898 3.77211L7.02534 4.10745C7.03915 4.15084 6.98956 4.18683 6.95242 4.16029L6.66562 3.95575L6.37888 4.16029C6.34174 4.18677 6.29226 4.15084 6.30596 4.10745L6.41232 3.77211L6.12878 3.56312C6.09209 3.53601 6.11098 3.47799 6.15663 3.47759L6.5091 3.47491L6.6206 3.14122C6.63504 3.09806 6.69626 3.09806 6.7107 3.14122Z'
        fill='white'
      />
      <path
        d='M6.7107 4.88667L6.8222 5.22036L7.17467 5.22304C7.22032 5.22344 7.23921 5.28152 7.20252 5.30857L6.91898 5.51756L7.02534 5.8529C7.03915 5.89629 6.98956 5.93228 6.95242 5.90575L6.66562 5.7012L6.37888 5.90575C6.34174 5.93223 6.29226 5.89629 6.30596 5.8529L6.41232 5.51756L6.12878 5.30857C6.09209 5.28146 6.11098 5.22344 6.15663 5.22304L6.5091 5.22036L6.6206 4.88667C6.63504 4.8435 6.69626 4.8435 6.7107 4.88667Z'
        fill='white'
      />
      <path
        d='M6.7107 6.63236L6.8222 6.96606L7.17467 6.96873C7.22032 6.96913 7.23921 7.02722 7.20252 7.05426L6.91898 7.26325L7.02534 7.59859C7.03915 7.64199 6.98956 7.67797 6.95242 7.65144L6.66562 7.44689L6.37888 7.65144C6.34174 7.67792 6.29226 7.64199 6.30596 7.59859L6.41232 7.26325L6.12878 7.05426C6.09209 7.02716 6.11098 6.96913 6.15663 6.96873L6.5091 6.96606L6.6206 6.63236C6.63504 6.58914 6.69626 6.58914 6.7107 6.63236Z'
        fill='white'
      />
      <path
        d='M6.7107 8.37785L6.8222 8.71155L7.17467 8.71422C7.22032 8.71462 7.23921 8.77271 7.20252 8.79976L6.91898 9.00874L7.02534 9.34409C7.03915 9.38748 6.98956 9.42347 6.95242 9.39693L6.66562 9.19239L6.37888 9.39693C6.34174 9.42341 6.29226 9.38748 6.30596 9.34409L6.41232 9.00874L6.12878 8.79976C6.09209 8.77265 6.11098 8.71462 6.15663 8.71422L6.5091 8.71155L6.6206 8.37785C6.63504 8.33458 6.69626 8.33458 6.7107 8.37785Z'
        fill='white'
      />
      <path
        d='M8.06888 2.25144L8.18038 2.58513L8.53285 2.58781C8.5785 2.58821 8.59739 2.64629 8.5607 2.67334L8.27716 2.88233L8.38352 3.21767C8.39733 3.26106 8.34774 3.29705 8.3106 3.27052L8.02386 3.06597L7.73712 3.27052C7.69997 3.297 7.6505 3.26106 7.66419 3.21767L7.77056 2.88233L7.48702 2.67334C7.45032 2.64624 7.46921 2.58821 7.51486 2.58781L7.86734 2.58513L7.97884 2.25144C7.99327 2.20828 8.05444 2.20828 8.06888 2.25144Z'
        fill='white'
      />
      <path
        d='M8.06888 3.99693L8.18038 4.33063L8.53285 4.3333C8.5785 4.3337 8.59739 4.39178 8.5607 4.41883L8.27716 4.62782L8.38352 4.96316C8.39733 5.00655 8.34774 5.04254 8.3106 5.01601L8.02386 4.81146L7.73712 5.01601C7.69997 5.04249 7.6505 5.00661 7.66419 4.96316L7.77056 4.62782L7.48702 4.41883C7.45032 4.39173 7.46921 4.3337 7.51486 4.3333L7.86734 4.33063L7.97884 3.99693C7.99327 3.95371 8.05444 3.95371 8.06888 3.99693Z'
        fill='white'
      />
      <path
        d='M8.06888 5.74258L8.18038 6.07628L8.53285 6.07895C8.5785 6.07935 8.59739 6.13744 8.5607 6.16448L8.27716 6.37347L8.38352 6.70882C8.39733 6.75221 8.34774 6.7882 8.3106 6.76166L8.02386 6.55712L7.73712 6.76166C7.69997 6.78814 7.6505 6.75221 7.66419 6.70882L7.77056 6.37347L7.48702 6.16448C7.45032 6.13738 7.46921 6.07935 7.51486 6.07895L7.86734 6.07628L7.97884 5.74258C7.99327 5.69936 8.05444 5.69936 8.06888 5.74258Z'
        fill='white'
      />
      <path
        d='M8.06888 7.48819L8.18038 7.82189L8.53285 7.82456C8.5785 7.82496 8.59739 7.88305 8.5607 7.91009L8.27716 8.11908L8.38352 8.45442C8.39733 8.49782 8.34774 8.5338 8.3106 8.50727L8.02386 8.30272L7.73712 8.50727C7.69997 8.53375 7.6505 8.49782 7.66419 8.45442L7.77056 8.11908L7.48702 7.91009C7.45032 7.88299 7.46921 7.82496 7.51486 7.82456L7.86734 7.82189L7.97884 7.48819C7.99327 7.44503 8.05444 7.44503 8.06888 7.48819Z'
        fill='white'
      />
      <path
        d='M9.42671 1.39561L9.53821 1.7293L9.89068 1.73198C9.93633 1.73238 9.95522 1.79046 9.91853 1.81751L9.63499 2.0265L9.74135 2.36184C9.75516 2.40523 9.70557 2.44122 9.66843 2.41468L9.38169 2.21014L9.09495 2.41468C9.0578 2.44116 9.00833 2.40523 9.02202 2.36184L9.12839 2.0265L8.84484 1.81751C8.80815 1.7904 8.82704 1.73238 8.87269 1.73198L9.22516 1.7293L9.33666 1.39561C9.35099 1.35239 9.41227 1.35239 9.42671 1.39561Z'
        fill='white'
      />
      <path
        d='M9.42671 3.14122L9.53821 3.47491L9.89068 3.47759C9.93633 3.47799 9.95522 3.53607 9.91853 3.56312L9.63499 3.77211L9.74135 4.10745C9.75516 4.15084 9.70557 4.18683 9.66843 4.16029L9.38169 3.95575L9.09495 4.16029C9.0578 4.18677 9.00833 4.15084 9.02202 4.10745L9.12839 3.77211L8.84484 3.56312C8.80815 3.53601 8.82704 3.47799 8.87269 3.47759L9.22516 3.47491L9.33666 3.14122C9.35099 3.09806 9.41227 3.09806 9.42671 3.14122Z'
        fill='white'
      />
      <path
        d='M9.42671 4.88667L9.53821 5.22036L9.89068 5.22304C9.93633 5.22344 9.95522 5.28152 9.91853 5.30857L9.63499 5.51756L9.74135 5.8529C9.75516 5.89629 9.70557 5.93228 9.66843 5.90575L9.38169 5.7012L9.09495 5.90575C9.0578 5.93223 9.00833 5.89629 9.02202 5.8529L9.12839 5.51756L8.84484 5.30857C8.80815 5.28146 8.82704 5.22344 8.87269 5.22304L9.22516 5.22036L9.33666 4.88667C9.35099 4.8435 9.41227 4.8435 9.42671 4.88667Z'
        fill='white'
      />
      <path
        d='M9.42671 6.63236L9.53821 6.96606L9.89068 6.96873C9.93633 6.96913 9.95522 7.02722 9.91853 7.05426L9.63499 7.26325L9.74135 7.59859C9.75516 7.64199 9.70557 7.67797 9.66843 7.65144L9.38169 7.44689L9.09495 7.65144C9.0578 7.67792 9.00833 7.64199 9.02202 7.59859L9.12839 7.26325L8.84484 7.05426C8.80815 7.02716 8.82704 6.96913 8.87269 6.96873L9.22516 6.96606L9.33666 6.63236C9.35099 6.58914 9.41227 6.58914 9.42671 6.63236Z'
        fill='white'
      />
      <path
        d='M9.42671 8.37785L9.53821 8.71155L9.89068 8.71422C9.93633 8.71462 9.95522 8.77271 9.91853 8.79976L9.63499 9.00874L9.74135 9.34409C9.75516 9.38748 9.70557 9.42347 9.66843 9.39693L9.38169 9.19239L9.09495 9.39693C9.0578 9.42341 9.00833 9.38748 9.02202 9.34409L9.12839 9.00874L8.84484 8.79976C8.80815 8.77265 8.82704 8.71462 8.87269 8.71422L9.22516 8.71155L9.33666 8.37785C9.35099 8.33458 9.41227 8.33458 9.42671 8.37785Z'
        fill='white'
      />
      <path
        d='M10.7849 2.25144L10.8964 2.58513L11.2489 2.58781C11.2946 2.58821 11.3135 2.64629 11.2768 2.67334L10.9932 2.88233L11.0996 3.21767C11.1134 3.26106 11.0638 3.29705 11.0267 3.27052L10.7399 3.06597L10.4532 3.27052C10.416 3.297 10.3666 3.26106 10.3803 3.21767L10.4866 2.88233L10.2031 2.67334C10.1664 2.64624 10.1853 2.58821 10.2309 2.58781L10.5834 2.58513L10.6949 2.25144C10.7093 2.20828 10.7706 2.20828 10.7849 2.25144Z'
        fill='white'
      />
      <path
        d='M10.7849 3.99693L10.8964 4.33063L11.2489 4.3333C11.2946 4.3337 11.3135 4.39178 11.2768 4.41883L10.9932 4.62782L11.0996 4.96316C11.1134 5.00655 11.0638 5.04254 11.0267 5.01601L10.7399 4.81146L10.4532 5.01601C10.416 5.04249 10.3666 5.00661 10.3803 4.96316L10.4866 4.62782L10.2031 4.41883C10.1664 4.39173 10.1853 4.3337 10.2309 4.3333L10.5834 4.33063L10.6949 3.99693C10.7093 3.95371 10.7706 3.95371 10.7849 3.99693Z'
        fill='white'
      />
      <path
        d='M10.7849 5.74258L10.8964 6.07628L11.2489 6.07895C11.2946 6.07935 11.3135 6.13744 11.2768 6.16448L10.9932 6.37347L11.0996 6.70882C11.1134 6.75221 11.0638 6.7882 11.0267 6.76166L10.7399 6.55712L10.4532 6.76166C10.416 6.78814 10.3666 6.75221 10.3803 6.70882L10.4866 6.37347L10.2031 6.16448C10.1664 6.13738 10.1853 6.07935 10.2309 6.07895L10.5834 6.07628L10.6949 5.74258C10.7093 5.69936 10.7706 5.69936 10.7849 5.74258Z'
        fill='white'
      />
      <path
        d='M10.7849 7.48819L10.8964 7.82189L11.2489 7.82456C11.2946 7.82496 11.3135 7.88305 11.2768 7.91009L10.9932 8.11908L11.0996 8.45442C11.1134 8.49782 11.0638 8.5338 11.0267 8.50727L10.7399 8.30272L10.4532 8.50727C10.416 8.53375 10.3666 8.49782 10.3803 8.45442L10.4866 8.11908L10.2031 7.91009C10.1664 7.88299 10.1853 7.82496 10.2309 7.82456L10.5834 7.82189L10.6949 7.48819C10.7093 7.44503 10.7706 7.44503 10.7849 7.48819Z'
        fill='white'
      />
      <path
        d='M12.1428 1.39561L12.2543 1.7293L12.6067 1.73198C12.6524 1.73238 12.6713 1.79046 12.6346 1.81751L12.3511 2.0265L12.4574 2.36184C12.4712 2.40523 12.4216 2.44122 12.3845 2.41468L12.0978 2.21014L11.811 2.41468C11.7739 2.44116 11.7244 2.40523 11.7381 2.36184L11.8445 2.0265L11.5609 1.81751C11.5242 1.7904 11.5431 1.73238 11.5888 1.73198L11.9412 1.7293L12.0527 1.39561C12.0671 1.35239 12.1283 1.35239 12.1428 1.39561Z'
        fill='white'
      />
      <path
        d='M12.1428 3.14122L12.2543 3.47491L12.6067 3.47759C12.6524 3.47799 12.6713 3.53607 12.6346 3.56312L12.3511 3.77211L12.4574 4.10745C12.4712 4.15084 12.4216 4.18683 12.3845 4.16029L12.0978 3.95575L11.811 4.16029C11.7739 4.18677 11.7244 4.15084 11.7381 4.10745L11.8445 3.77211L11.5609 3.56312C11.5242 3.53601 11.5431 3.47799 11.5888 3.47759L11.9412 3.47491L12.0527 3.14122C12.0671 3.09806 12.1283 3.09806 12.1428 3.14122Z'
        fill='white'
      />
      <path
        d='M12.1428 4.88667L12.2543 5.22036L12.6067 5.22304C12.6524 5.22344 12.6713 5.28152 12.6346 5.30857L12.3511 5.51756L12.4574 5.8529C12.4712 5.89629 12.4216 5.93228 12.3845 5.90575L12.0978 5.7012L11.811 5.90575C11.7739 5.93223 11.7244 5.89629 11.7381 5.8529L11.8445 5.51756L11.5609 5.30857C11.5242 5.28146 11.5431 5.22344 11.5888 5.22304L11.9412 5.22036L12.0527 4.88667C12.0671 4.8435 12.1283 4.8435 12.1428 4.88667Z'
        fill='white'
      />
      <path
        d='M12.1428 6.63236L12.2543 6.96606L12.6067 6.96873C12.6524 6.96913 12.6713 7.02722 12.6346 7.05426L12.3511 7.26325L12.4574 7.59859C12.4712 7.64199 12.4216 7.67797 12.3845 7.65144L12.0978 7.44689L11.811 7.65144C11.7739 7.67792 11.7244 7.64199 11.7381 7.59859L11.8445 7.26325L11.5609 7.05426C11.5242 7.02716 11.5431 6.96913 11.5888 6.96873L11.9412 6.96606L12.0527 6.63236C12.0671 6.58914 12.1283 6.58914 12.1428 6.63236Z'
        fill='white'
      />
      <path
        d='M12.1428 8.37785L12.2543 8.71155L12.6067 8.71422C12.6524 8.71462 12.6713 8.77271 12.6346 8.79976L12.3511 9.00874L12.4574 9.34409C12.4712 9.38748 12.4216 9.42347 12.3845 9.39693L12.0978 9.19239L11.811 9.39693C11.7739 9.42341 11.7244 9.38748 11.7381 9.34409L11.8445 9.00874L11.5609 8.79976C11.5242 8.77265 11.5431 8.71462 11.5888 8.71422L11.9412 8.71155L12.0527 8.37785C12.0671 8.33458 12.1283 8.33458 12.1428 8.37785Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_16973_45794'>
        <rect width='26.6667' height='20' rx='2' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
